export default function getTealiumHeadSnippet() {
  return ` 
  var trackingQueue = []; var eventQueue = []; var consentCallbackQueue = [];
  function sendPageView(trackingObject) {trackingQueue.push(trackingObject)}
  function sendEvent(event) {eventQueue.push(event)}
  function waitForUserConsent(callback) {consentCallbackQueue.push(callback)}
`;
}
